import React, { memo } from 'react'
import styles from './styles.module.scss'
import { useExpectedBudget } from './useExpectedBudget.hook'
import { BUDGET_OPTIONS } from './constants'
import { BudgetOption } from './BudgetOption'
import ProgressBar from '../ProgressBar'

const ExpectedBudgetPage: React.FC = () => {
  const { selectedBudget, handleSelectBudget, handleSubmit, isValid } = useExpectedBudget()

  return (
    <>
      <ProgressBar />
      <div className={styles.expectedBudgetPage}>
        <div className={styles.expectedBudgetLeftSection}>
          <div className={styles.expectedBudgetTextContainer}>
            <h2 className={styles.expectedBudgetTitle}>How much are you looking to spend?</h2>
            <p className={styles.expectedBudgetDescription}>Poppy has a $1,750 order minimum.</p>
            <button
              className={`${styles.expectedBudgetButton} ${isValid ? styles.hasValue : ''}`}
              onClick={handleSubmit}
              disabled={!isValid}
            >
              Next
            </button>
          </div>
        </div>

        <div className={styles.expectedBudgetRightSection}>
          <div className={styles.budgetOptionsContainer}>
            {BUDGET_OPTIONS.map((option) => (
              <BudgetOption
                key={option.value}
                value={option.value}
                label={option.label}
                isSelected={selectedBudget === option.value}
                onSelect={handleSelectBudget}
              />
            ))}
          </div>
        </div>
        <button
          className={`${styles.expectedBudgetButtonMobile} ${isValid ? styles.hasValue : ''}`}
          onClick={handleSubmit}
          disabled={!isValid}
        >
          Next
        </button>
      </div>
    </>
  )
}

ExpectedBudgetPage.displayName = 'ExpectedBudgetPage'

export default memo(ExpectedBudgetPage)
